import classNames from "classnames";
import moment from "moment";
import React from "react";
import {
	EBallastOperationCodes,
	TBallastRecord,
} from "../../../../../redux/app/ballast/@types";
import { TBallast_Ballast } from "../../../../../redux/app/ballast/groups/ballast";
import { TBallast_Deballast } from "../../../../../redux/app/ballast/groups/deballast";
import CommaSeparator from "../../../../_common/CommaSeparator";
import { commonUtils } from "redux/_common";
import ballastUtils from "redux/app/ballast/utils";
import BallastTableRows from "../_elements/BallastTableRows";

import versions from "../../../../../redux/app/ballast/versions";

type OwnProps = {
	ballastRecord: TBallastRecord;
	isStrikedOff?: boolean;
};
type DeballastOperationPreviewProps = OwnProps;
function DeballastOperationPreview(props: DeballastOperationPreviewProps) {
	const record = props.ballastRecord as TBallast_Deballast;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);
	const { placeOfBallast, operationCode } =
		props.ballastRecord as TBallast_Deballast;

	function renderMain() {
		if (record.version === versions[0].value) {
			if (
				record.operationCode ===
				EBallastOperationCodes.DEBALLAST_TO_RECEPTION_FACILITY_MEPC80
			) {
				return (
					<BallastTableRows
						record={record}
						tableRows={[
							[operationDate, "D", "1", render1f()],
							[null, null, "2", render2f()],
							[null, null, "3", render3f()],
							[null, null, "4", render4f()],
							[null, null, "5", render5f()],
							[null, null, "6", render6f()],
							[null, null, "7", render7f()],
							[null, null, "NOTE", record.remarks],
						]}
					/>
				);
			} else {
				return (
					<BallastTableRows
						record={record}
						tableRows={[
							[operationDate, "B", "1", renderItem1()],
							[null, null, "2", renderItem2()],
							[null, null, "3", renderItem3()],
							[null, null, "4", renderItem4()],
							[null, null, "5", renderItem5()],
							[null, null, "6", renderItem6()],
							[null, null, "NOTE", record.remarks],
						]}
					/>
				);
			}
		} else {
			return (
				<BallastTableRows
					record={record}
					tableRows={[
						[operationDate, null, "3.4.1", renderItem3P4P1()],
						[null, null, "3.4.2", renderItem3P4P2()],
						[null, null, "3.4.3", renderItem3P4P3()],
						[null, null, "3.4.4", renderItem3P4P4()],
						[null, null, "3.4.5", renderItem3P4P5()],
						[operationDate, null, "3.3.1", renderItem3P3P1()],
						[null, null, "3.3.2", renderItem3P3P2()],
						[null, null, "3.3.3", renderItem3P3P3()],
						[null, null, "NOTE", record.remarks],
					]}
				/>
			);
		}
	}

	// MEPC.369(80)
	// Uptake/discharge reception facility
	function render1f() {
		if (
			operationCode !==
				EBallastOperationCodes.DEBALLAST_TO_RECEPTION_FACILITY_MEPC80 ||
			placeOfBallast.place !== "AT_RECEPTION_FACILITY"
		)
			return null;

		const smtStartDate = record.tanks[0].startDate;
		const smtStartTime = record.tanks[0].startTime;
		if (record.timeZone) {
			const dateTimeLocal = `${smtStartDate}T${smtStartTime}:00${record.timeZone}`;
			const utcTime = moment.utc(dateTimeLocal);
			return (
				<>
					Start - {utcTime.format("HH:mm")} hrs (UTC) on{" "}
					{utcTime.format("DD-MMM-YYYY")}, ({smtStartTime} SMT) on{" "}
					{moment(smtStartDate, "YYYY-MM-DD").format("DD-MMM-YYYY")} from{" "}
					{placeOfBallast.receptionFacilityName} at the Port of{" "}
					{placeOfBallast.portName}
				</>
			);
		} else {
			return (
				<>
					Start - {placeOfBallast.startTime} hrs (UTC) on{" "}
					{moment(placeOfBallast.startDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
					from {placeOfBallast.receptionFacilityName} at the Port of{" "}
					{placeOfBallast.portName}
				</>
			);
		}
	}
	function render2f() {
		const smtEndDate = record.tanks[record.tanks.length - 1].endDate;
		const smtEndTime = record.tanks[record.tanks.length - 1].endTime;
		if (record.timeZone) {
			const dateTimeLocal = `${smtEndDate}T${smtEndTime}:00${record.timeZone}`;
			const utcTime = moment.utc(dateTimeLocal);
			return (
				<>
					Completion - {utcTime.format("HH:mm")} hrs (UTC) on{" "}
					{utcTime.format("DD-MMM-YYYY")}, ({smtEndTime} SMT) on{" "}
					{moment(smtEndDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
					{/* on{' '}
                    {moment(smtEndDate, 'YYYY-MM-DD').format('DD-MMM-YYYY')}{' '} */}
				</>
			);
		} else {
			return (
				<>
					Completion - {record.tanks[record.tanks.length - 1].endTime} hrs (UTC)
					{/* on{' '}
                    {moment(
                        record.tanks[record.tanks.length - 1].endDate,
                        'YYYY-MM-DD'
                    ).format('DD-MMM-YYYY')}{' '} */}
				</>
			);
		}
	}
	function render3f() {
		if (
			operationCode !==
				EBallastOperationCodes.DEBALLAST_TO_RECEPTION_FACILITY_MEPC80 ||
			placeOfBallast.place !== "AT_RECEPTION_FACILITY"
		)
			return null;
		return <h4 className="font-medium uppercase">{placeOfBallast.type}</h4>;
	}
	function render4f() {
		let tankNames = "";
		record.tanks.forEach((tank, index) => {
			tankNames += tank.selectedTank.tankCode;
			if (index !== record.tanks.length - 1) {
				tankNames += ",";
			}
		});
		return tankNames;
	}
	function render5f() {
		let accumulatedValue = 0;
		accumulatedValue = record.tanks.reduce(
			(acc, curr) => acc + curr.newRetainedQuantity,
			0
		);
		return (
			<h4 className="font-medium uppercase">
				{record.totalOperatedWaterVolume} M³. Final quantity retained:{" "}
				{record.ballastROB.toFixed(2)} M³
			</h4>
		);
	}
	function render6f() {
		return <h4 className="font-medium uppercase">{record.approvedBWMP}</h4>;
	}
	function render7f() {
		return <h4 className="font-medium uppercase">{record.treatmentMethod}</h4>;
	}
	// Deballast
	function renderItem1() {
		const smtStartDate = record.tanks[0].startDate;
		const smtStartTime = record.tanks[0].startTime;
		if (record.timeZone) {
			const dateTimeLocal = `${smtStartDate}T${smtStartTime}:00${record.timeZone}`;
			const utcTime = moment.utc(dateTimeLocal);

			return (
				<>
					{record.placeOfBallast.place === "IN_PORT" ? (
						<>
							Start - {utcTime.format("HH:mm")} hrs (UTC) on{" "}
							{utcTime.format("DD-MMM-YYYY")}, ({smtStartTime} SMT) on{" "}
							{moment(smtStartDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
							{/* on{' '}
                            {moment(smtStartDate, 'YYYY-MM-DD').format(
                                'DD-MMM-YYYY'
                            )}{' '} */}{" "}
							at {record.placeOfBallast.portName}
						</>
					) : null}
					{record.placeOfBallast.place === "AT_SEA" ? (
						<>
							Start - {utcTime.format("HH:mm")} hrs (UTC) on{" "}
							{utcTime.format("DD-MMM-YYYY")}, ({smtStartTime} SMT) on{" "}
							{moment(smtStartDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
							{/* on{' '}
                            {moment(smtStartDate, 'YYYY-MM-DD').format(
                                'DD-MMM-YYYY'
                            )}{' '} */}{" "}
							at Lat {record.placeOfBallast.startPosition.latitude} / Long{" "}
							{record.placeOfBallast.startPosition.longitude}
						</>
					) : null}
				</>
			);
		} else {
			return (
				<>
					{record.placeOfBallast.place === "IN_PORT" ? (
						<>
							Start - {smtStartTime} hrs (UTC)
							{/* on{' '}
                            {moment(smtStartDate, 'YYYY-MM-DD').format(
                                'DD-MMM-YYYY'
                            )}{' '} */}{" "}
							at {record.placeOfBallast.portName}
						</>
					) : null}
					{record.placeOfBallast.place === "AT_SEA" ? (
						<>
							Start - {smtStartTime} hrs (UTC)
							{/* on{' '}
                            {moment(smtStartDate, 'YYYY-MM-DD').format(
                                'DD-MMM-YYYY'
                            )}{' '} */}{" "}
							at Lat {record.placeOfBallast.startPosition.latitude} / Long{" "}
							{record.placeOfBallast.startPosition.longitude}
						</>
					) : null}
				</>
			);
		}
	}
	function renderItem2() {
		const smtEndDate = record.tanks[record.tanks.length - 1].endDate;
		const smtEndTime = record.tanks[record.tanks.length - 1].endTime;
		if (record.timeZone) {
			const dateTimeLocal = `${smtEndDate}T${smtEndTime}:00${record.timeZone}`;
			const utcTime = moment.utc(dateTimeLocal);
			return (
				<>
					{record.placeOfBallast.place === "IN_PORT" ? (
						<>
							Completion - {utcTime.format("HH:mm")} hrs (UTC) on{" "}
							{utcTime.format("DD-MMM-YYYY")}, ({smtEndTime} SMT) on{" "}
							{moment(smtEndDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
							{/* on{' '}
                            {moment(smtEndDate, 'YYYY-MM-DD').format(
                                'DD-MMM-YYYY'
                            )} */}{" "}
							at {record.placeOfBallast.portName}
						</>
					) : null}
					{record.placeOfBallast.place === "AT_SEA" ? (
						<>
							Completion - {utcTime.format("HH:mm")} hrs (UTC) on{" "}
							{utcTime.format("DD-MMM-YYYY")}, ({smtEndTime} SMT) on{" "}
							{moment(smtEndDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
							{/* on{' '}
                            {moment(smtEndDate, 'YYYY-MM-DD').format(
                                'DD-MMM-YYYY'
                            )} */}{" "}
							at Lat {record.placeOfBallast.endPosition.latitude}/ Long{" "}
							{record.placeOfBallast.endPosition.longitude}, at {record.depth}m
							minimum depth
						</>
					) : null}
				</>
			);
		} else {
			return (
				<>
					{record.placeOfBallast.place === "IN_PORT" ? (
						<>
							Completion - {record.tanks[record.tanks.length - 1].endTime} hrs
							(UTC) ({record.tanks[record.tanks.length - 1].endTime} SMT)
							{/* on{' '}
                            {moment(
                                record.tanks[record.tanks.length - 1].endDate,
                                'YYYY-MM-DD'
                            ).format('DD-MMM-YYYY')} */}{" "}
							at {record.placeOfBallast.portName}
						</>
					) : null}
					{record.placeOfBallast.place === "AT_SEA" ? (
						<>
							Completion - {record.tanks[record.tanks.length - 1].endTime} hrs
							(UTC)
							{/* on{' '}
                            {moment(
                                record.tanks[record.tanks.length - 1].endDate,
                                'YYYY-MM-DD'
                            ).format('DD-MMM-YYYY')} */}{" "}
							at Lat {record.placeOfBallast.endPosition.latitude}/ Long{" "}
							{record.placeOfBallast.endPosition.longitude}, at {record.depth}m
							minimum depth
						</>
					) : null}
				</>
			);
		}
	}
	function renderItem3() {
		let tankNames = "";
		record.tanks.forEach((tank, index) => {
			tankNames += tank.selectedTank.tankCode;
			if (index !== record.tanks.length - 1) {
				tankNames += ",";
			}
		});
		return tankNames;
	}
	function renderItem4() {
		// let accumulatedValue = 0;
		// accumulatedValue = record.tanks.reduce(
		//     (acc, curr) => acc + curr.newRetainedQuantity,
		//     0
		// );
		return (
			<h4 className="font-medium uppercase">
				Discharged {record.totalOperatedWaterVolume} M³. Final quantity
				retained: {record.ballastROB.toFixed(2)} M³
			</h4>
		);
	}
	function renderItem5() {
		return <h4 className="font-medium uppercase">{record.approvedBWMP}</h4>;
	}
	function renderItem6() {
		return <h4 className="font-medium uppercase">{record.treatmentMethod}</h4>;
	}

	// MEPC 70
	function renderItem3P4P1() {
		if (
			operationCode !==
				EBallastOperationCodes.DEBALLAST_TO_RECEPTION_FACILITY ||
			placeOfBallast.place !== "AT_RECEPTION_FACILITY"
		)
			return null;
		return (
			<h4 className="font-medium uppercase">
				{moment(placeOfBallast.startDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
				{placeOfBallast.startTime}, {placeOfBallast.originOfBallast}
			</h4>
		);
	}

	function renderItem3P4P2() {
		if (
			operationCode !==
				EBallastOperationCodes.DEBALLAST_TO_RECEPTION_FACILITY ||
			placeOfBallast.place !== "AT_RECEPTION_FACILITY"
		)
			return null;
		return (
			<h4 className="font-medium uppercase">
				{moment(record.tanks[0].startDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
				{record.tanks[0].startTime}, {placeOfBallast.receptionFacilityName}
			</h4>
		);
	}

	function renderItem3P4P3() {
		if (
			operationCode !==
				EBallastOperationCodes.DEBALLAST_TO_RECEPTION_FACILITY ||
			placeOfBallast.place !== "AT_RECEPTION_FACILITY"
		)
			return null;
		return (
			<h4 className="font-medium uppercase">
				{placeOfBallast.receptionFacilityName}
			</h4>
		);
	}

	function renderItem3P4P4() {
		if (
			operationCode !==
				EBallastOperationCodes.DEBALLAST_TO_RECEPTION_FACILITY ||
			placeOfBallast.place !== "AT_RECEPTION_FACILITY"
		)
			return null;
		return (
			<h4 className="font-medium uppercase">
				{record.totalOperatedWaterVolume} M³
			</h4>
		);
	}

	function renderItem3P4P5() {
		if (
			operationCode !==
				EBallastOperationCodes.DEBALLAST_TO_RECEPTION_FACILITY ||
			placeOfBallast.place !== "AT_RECEPTION_FACILITY"
		)
			return null;
		return <h4 className="font-medium uppercase">NO</h4>;
	}

	function renderItem3P3P1() {
		if (
			operationCode ===
				EBallastOperationCodes.DEBALLAST_TO_RECEPTION_FACILITY ||
			placeOfBallast.place === "AT_RECEPTION_FACILITY"
		)
			return null;
		return (
			<h4 className="font-medium uppercase">
				{moment(record.tanks[0].startDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
				{record.tanks[0].startTime} to{" "}
				{moment(
					record.tanks[record.tanks.length - 1].endDate,
					"YYYY-MM-DD"
				).format("DD-MMM-YYYY")}{" "}
				{record.tanks[record.tanks.length - 1].endTime},{" "}
				{placeOfBallast.place === "IN_PORT" ? (
					<>{placeOfBallast.portName}</>
				) : null}
				{placeOfBallast.place === "AT_SEA" ? (
					<>
						({placeOfBallast.startPosition.latitude},{" "}
						{placeOfBallast.startPosition.longitude}, to{" "}
						{placeOfBallast.endPosition.latitude},{" "}
						{placeOfBallast.endPosition.longitude})
					</>
				) : null}
			</h4>
		);
	}

	function renderItem3P3P2() {
		if (
			operationCode ===
				EBallastOperationCodes.DEBALLAST_TO_RECEPTION_FACILITY ||
			placeOfBallast.place === "AT_RECEPTION_FACILITY"
		)
			return null;
		return (
			<h4 className="font-medium uppercase">
				{operationCode === EBallastOperationCodes.DEBALLAST_IN_PORT ? (
					<>
						Discharged: {record.totalOperatedWaterVolume} M³,
						{record.ballastROB
							? `Total Ballast Retained Quantity on Board: ${record.ballastROB.toFixed(
									2
							  )}M³`
							: `:Total Quantity Retained ${totalQuantityRetained().toFixed(
									2
							  )} M³`}
					</>
				) : (
					<>
						Discharged: {record.totalOperatedWaterVolume} M³,
						{/* Quantity retained in{' '} */}
						{/* {getParticipantTankNames(record)} :{' '} */}
						{record.ballastROB
							? `Total Ballast Retained Quantity on Board: ${record.ballastROB.toFixed(
									2
							  )}M³`
							: `Total Quantity Retained: ${totalQuantityRetained().toFixed(
									2
							  )} M³`}
					</>
				)}
			</h4>
		);
	}

	function renderItem3P3P3() {
		if (
			operationCode ===
				EBallastOperationCodes.DEBALLAST_TO_RECEPTION_FACILITY ||
			placeOfBallast.place === "AT_RECEPTION_FACILITY"
		)
			return null;
		if (!record.isBallastWaterTreatmentPlanUsed) return null;
		return <h4 className="font-medium uppercase">YES</h4>;
	}

	const totalQuantityRetained = () => {
		let accumulatedValue = 0;
		if (record.ballastROB) {
			accumulatedValue = record.tanks.reduce(
				(acc, curr) => acc + curr.newRetainedQuantity,
				0
			);
		} else {
			accumulatedValue = record.tanks.reduce(
				(acc, curr) =>
					commonUtils.addUp(
						commonUtils.substract(
							curr.selectedTank.expectedQuantity,
							curr.transferQuantity
						),
						acc
					),
				0
			);
		}
		return accumulatedValue;
	};

	return renderMain();
}

export default DeballastOperationPreview;
